import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { MapPinIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Events() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    t
  } = useLanguage();
  const events = [{
    day: '15',
    month: '04',
    title: 'IT Cluster Summit 2026',
    location: 'Budapest, Hungary',
    descKey: 'events.e1.desc'
  }, {
    day: '28',
    month: '04',
    title: 'Startup Pitch Day',
    location: 'Online',
    descKey: 'events.e2.desc'
  }, {
    day: '10',
    month: '05',
    title: 'Tech Education Forum',
    location: 'Vienna, Austria',
    descKey: 'events.e3.desc'
  }];
  return <section id="events" ref={ref} className="relative w-full overflow-hidden px-4 py-16 sm:py-24" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderTop: '1px solid var(--border)'
  }} data-id="element-64">
      <div className="relative z-10 mx-auto max-w-4xl" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-12 sm:mb-16 text-center" data-id="element-66">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-67">
            {t('events.title')}
          </h2>
          <p className="text-lg" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-68">
            {t('events.desc')}
          </p>
        </motion.div>

        <div className="flex flex-col gap-6" data-id="element-69">
          {events.map((event, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} data-id="element-70">
              <div className="group rounded-2xl border p-6 flex flex-col sm:flex-row gap-6 items-start sm:items-center transition-all hover:shadow-md" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-primary)'
          }} data-id="element-71">
                {/* Date Badge */}
                <div className="flex flex-col items-center justify-center w-20 h-20 rounded-xl flex-shrink-0" style={{
              backgroundColor: 'var(--bg-tertiary)'
            }} data-id="element-72">
                  <span className="text-2xl font-bold" style={{
                color: 'var(--accent)'
              }} data-id="element-73">
                    {event.day}
                  </span>
                  <span className="text-sm font-medium" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-74">
                    {event.month}
                  </span>
                </div>

                {/* Content */}
                <div className="flex-1" data-id="element-75">
                  <h3 className="text-xl font-bold mb-2" style={{
                color: 'var(--text-primary)'
              }} data-id="element-76">
                    {event.title}
                  </h3>
                  <div className="flex items-center gap-2 mb-3 text-sm font-medium" style={{
                color: 'var(--text-muted)'
              }} data-id="element-77">
                    <MapPinIcon className="w-4 h-4" data-id="element-78" />
                    {event.location}
                  </div>
                  <p className="text-base" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-79">
                    {t(event.descKey)}
                  </p>
                </div>

                {/* Action */}
                <button className="mt-4 sm:mt-0 p-3 rounded-xl transition-colors group-hover:bg-[var(--accent)] group-hover:text-white" style={{
              backgroundColor: 'var(--bg-tertiary)',
              color: 'var(--text-primary)'
            }} aria-label="Event details" data-id="element-80">
                  <ArrowRightIcon className="w-5 h-5" data-id="element-81" />
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}